// Farol aceso na frente do carro, à noite: 2×1 pixels no tom mais claro da luz. O brilho em volta
// não é sprite: vem pré-desenhado em ceu-desenho.ts (brilho), para não custar nada por quadro.

import { sprite } from './pix.js';
import type { PixelSprite } from './types.js';

export const FAROL: PixelSprite = sprite(['LL'], { L: 'light3' });

/** Cor do brilho do farol (o mesmo tom do pixel acima). */
export const FAROL_COR = 'rgba(255, 244, 200, 1)';
